import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";

// Downloads all clients as a CSV from the v2 endpoint. Uses a direct fetch
// (rather than an RTK Query hook) because the response is a file, not JSON, and
// we want to stream it straight to a browser download.
export const useDownloadClientsCsv = () => {
  const token = useSelector((state: RootState) => state.auth.token);

  return async (): Promise<void> => {
    const res = await fetch(
      `${process.env.REACT_APP_SCOPESTACK_API_HOST}/v2/clients/downloads`,
      { headers: { Authorization: `Bearer ${token}`, Accept: "text/csv" } }
    );
    if (!res.ok) {
      throw new Error(`Download failed (${res.status})`);
    }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "clients.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };
};

export default useDownloadClientsCsv;
